// Diners is a tSurya addition, so it ships in the blueprint's staticContent instead of the platform's wwwroot.
const cardImageUrlsByType: Record<string, string> = {
    "american express": "/images/card-types/amex.webp",
    discover: "/images/card-types/discover.webp",
    mastercard: "/images/card-types/mc.webp",
    visa: "/images/card-types/visa.webp",
    diners: "/staticContent/images/card-types/diners.webp",
};

export const getCardTypeImageUrl = (cardType: string) => cardImageUrlsByType[cardType.toLowerCase()] ?? "";
